const SET_FILTER = 'SET_FILTER';
const TOGGLE_AUTOMATIC_SPATIAL_QUERY = 'TOGGLE_AUTOMATIC_SPATIAL_QUERY';

export default {
  SET_FILTER,
  TOGGLE_AUTOMATIC_SPATIAL_QUERY
};



// WEBPACK FOOTER //
// ./src/redux/dataGridFilters/types.js